import PageLayout from "components/layout/PageLayout"



const LicenseAlert = () => {

    const content = (
        <>
            <p>Sorry, your license is expired</p>
        </>
    )


    return <PageLayout
        pageTitle={"License expired"}
        bodyContent={content}
    />

}

export default LicenseAlert